import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'frodo-order-not-available',
  templateUrl: './order-not-available.component.html',
  styleUrls: ['./order-not-available.component.scss'],
})
export class OrderNotAvailableComponent {
  showGdprDisclaimer: boolean;

  constructor(
    private dialogRef: MatDialogRef<OrderNotAvailableComponent>,
    @Inject(MAT_DIALOG_DATA) data: { showGdprDisclaimer: boolean }
  ) {
    this.showGdprDisclaimer = data.showGdprDisclaimer;
  }

  onReEnterCode(): void {
    this.dialogRef.close({ event: 'close' });
  }

  onNotifyMe(): void {
    this.dialogRef.close({ event: 'notify' });
  }

  get modalSizeClass(): string {
    return this.showGdprDisclaimer ? 'showBigModal' : 'showSmallModal';
  }
}
